import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
  dropdownContainer: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 12px 16px 12px",
    width: 280,
    height: 44,
    backgroundColor: Color.neutral[100],
    cursor: "pointer",
  }),
  dropdownText: css({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  }),
  dropdownArrowIcon: css({
    color: Color.primary[600],
    width: 24,
    height: 24,
  }),
});
